import { request } from '@/request';

export async function deleteProject(projectId: string): Promise<void> {
  return await request(`/projects/${projectId}`, 'delete');
}
